import React from "react";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useMyContext } from "../../myContext";

const DatePicker = ({ date, onChange, color, minDate, maxDate }) => {
  const {themeColor} = useMyContext("");
  const handleDateChange = (newDate) => {
    onChange(newDate);
  };

  return (
    <Calendar
      date={date}
      onChange={handleDateChange}
      color={themeColor ? themeColor : color}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
};

export default DatePicker;
